import { Action } from '../config';
import { EventProvider } from '../config/networkConfig';

export enum EventType {
  SUCCESS = 'success',
  FAILURE = 'failure',
  CANCELLED = 'cancelled',
  IN_PROGRESS = 'inProgress',
}

export interface Event {
  event: EventType;
  action: Action;
  payload?: EventPayload;
  requiresProofOfWalletOwnership?: boolean;
  instanceId?: string;
}

export interface EventPayload {
  provider?: EventProvider;
  acceptedDeclaration?: string;
  acceptedTermsAndConditionsLink?: string;
  acceptedBiometricsPolicyLink?: string;
  acceptedPrivacyPolicyLink?: string;
}

export interface EventEmitter {
  emit(event: Event): void;
}
